/**
 * Imports the necessary dependencies for a React component that uses translation and
 * renders a Card component with custom breadcrumbs.
 * @module React
 * @module react-i18next
 * @module react-bootstrap/Card
 * @module ../../../components/customBreadcrumb/customBreadcrumb
 * @returns None
 */
import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import Helmet from "react-helmet";
import { useTranslation } from "react-i18next";
import { CardBody, Label } from "reactstrap";
import CustomButton from "../../../components/customButton/customButton";
import HookForm from "../../../components/hookForm/hookForm";
import TextField from "../../../components/textField/textField";

const ChangePasswordComponent = (props) => {
  /**
   * Retrieves the translation function from the useTranslation hook.
   * Destructures the pageTitle property from the props object.
   * @returns None
   */
  const { t } = useTranslation();

  const {
    onFormSubmit,
    resetForm,
    multiErrorFields,
    show,
    t_show,
    showconfirm,
    t_show2,
    onClickCancel,
    busy,
    dimensions,
    showOld,
    t_show_old,
  } = props;

  return (
    <React.Fragment>
      <Helmet>
        <title>Change Password | RizzTix </title>
      </Helmet>
      <div
        className="authPages changePasswordPage"
        style={{ height: dimensions.height }}
      >
        <Container>
          <Row className="justify-content-center">
            <Col className="cardWrapperChanegPassword">
              <Card className="overflow-hidden forgotStyle">
                <CardBody className="Card_Body">
                  <div className="changePasswordPageLabel">
                    <span>{t("CHANGE_PASSWORD")}</span>
                  </div>
                  <div className="">
                    <HookForm
                      defaultForm={{}}
                      // init={(from) => setResetForm(resetform)}
                      onSubmit={(e) => onFormSubmit(e)}
                    >
                      {(formMethod) => {
                        return (
                          <div
                            className={
                              formMethod?.formState.errors ? "invalid" : ""
                            }
                          >
                            <div className="mb-4">
                              <div className="d-flex">
                                <Label>{t("OLD_PASSWORD")}</Label>
                                <Label className="requiredStyle">*</Label>
                              </div>
                              <div className="input-group auth-pass-inputgroup">
                                <TextField
                                  formMethod={formMethod}
                                  rules={resetForm.oldpassword.validate}
                                  errors={formMethod?.formState.errors}
                                  name={resetForm.oldpassword.name}
                                  iconError={formMethod?.formState.errors}
                                  type={!showOld ? "text" : "password"}
                                  placeholder={t("Enter Old password")}
                                  iconRightShow={true}
                                  onChange={(value) => {
                                    formMethod?.watch("password") &&
                                      formMethod.trigger("password");
                                  }}
                                  defaultValue=""
                                />
                                <button
                                  tabindex="-1"
                                  onClick={t_show_old}
                                  className="btn btn-light "
                                  type="button"
                                  id="password-addon"
                                >
                                  <i
                                    className={
                                      !showOld
                                        ? "mdi mdi-eye-outline"
                                        : "mdi mdi-eye-off-outline"
                                    }
                                  ></i>{" "}
                                </button>
                              </div>
                            </div>
                            <div className="mb-4">
                              <div className="d-flex">
                                <Label>{t("NEW_PASSWORD")}</Label>
                                <Label className="requiredStyle">*</Label>
                              </div>
                              <div className="input-group auth-pass-inputgroup">
                                <TextField
                                  formMethod={formMethod}
                                  rules={resetForm.newpassword.validate}
                                  multiErrorFields={multiErrorFields}
                                  errors={formMethod?.formState.errors}
                                  name={resetForm.newpassword.name}
                                  iconError={formMethod?.formState.errors}
                                  type={!show ? "text" : "password"}
                                  placeholder={t("Enter new password")}
                                  iconRightShow={true}
                                  onChange={(value) => {
                                    formMethod?.watch("password") &&
                                      formMethod.trigger("password");
                                  }}
                                  defaultValue=""
                                />
                                <button
                                  tabindex="-1"
                                  onClick={t_show}
                                  className="btn btn-light "
                                  type="button"
                                  id="password-addon"
                                >
                                  <i
                                    className={
                                      !show
                                        ? "mdi mdi-eye-outline"
                                        : "mdi mdi-eye-off-outline"
                                    }
                                  ></i>{" "}
                                </button>
                              </div>
                            </div>
                            <div className="mb-4">
                              <div className="d-flex">
                                <Label>{t("CONFIRM_PASSWORD")}</Label>
                                <Label className="requiredStyle">*</Label>
                              </div>
                              <div className="input-group auth-pass-inputgroup">
                                <TextField
                                  formMethod={formMethod}
                                  rules={{
                                    required: {
                                      value: true,
                                      message: t(
                                        "PLEASE_ENTER_CONFIRM_PASSWORD"
                                      ),
                                    },
                                    validate: {
                                      matchPassword: (value) =>
                                        (value &&
                                          value ===
                                            formMethod?.watch("newpassword")) ||
                                        t("BOTH_PASSWORD_MUST_BE_MATCH"),
                                    },
                                  }}
                                  name={resetForm.password.name}
                                  errors={formMethod?.formState.errors}
                                  type={!showconfirm ? "text" : "password"}
                                  placeholder={t("Confirm password")}
                                  onChange={(e) => {
                                    formMethod?.watch("newpassword") &&
                                      formMethod.trigger("newpassword");
                                  }}
                                />
                                <button
                                  tabindex="-1"
                                  onClick={t_show2}
                                  className="btn btn-light "
                                  type="button"
                                  id="password-addon"
                                >
                                  <i
                                    className={
                                      !showconfirm
                                        ? "mdi mdi-eye-outline"
                                        : "mdi mdi-eye-off-outline"
                                    }
                                  ></i>{" "}
                                </button>
                              </div>
                            </div>
                            <div className="d-grid">
                              <CustomButton
                                className="btn darkBtn btn-block"
                                type="submit"
                                title="Update"
                                disabled={!formMethod?.formState.isValid}
                                loading={busy}
                              />
                              <CustomButton
                                className="btn btn-primary btn-block mt-4 cancelBtnStyle"
                                onClick={onClickCancel}
                                type="button"
                                title="Cancel"
                              />
                            </div>
                          </div>
                        );
                      }}
                    </HookForm>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ChangePasswordComponent;
